const RevM = [
    {id: "0", value: "年累積YoY"},    
    {id: "1", value: "月MoM"},
    {id: "2", value: "月YoY"},      
  ];  
  
  export default RevM  